export const SUBSCRIBE_BUTTON_DATA_TEST_ID = 'subscribe-button';
export const ACTIVE_SUBSCRIBE_BELL_DATA_TEST_ID = 'active-subscribe-bell';
export const SUBSCRIBE_BELL_DATA_TEST_ID = 'subscribe-bell';
